import { render, staticRenderFns } from "./ItemNegociacoes.vue?vue&type=template&id=3a6fa1e2&scoped=true&"
import script from "./ItemNegociacoes.vue?vue&type=script&lang=js&"
export * from "./ItemNegociacoes.vue?vue&type=script&lang=js&"
import style0 from "./ItemNegociacoes.vue?vue&type=style&index=0&id=3a6fa1e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6fa1e2",
  null
  
)

export default component.exports